import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { SmartphoneComponent } from './component/smartphone.component';

import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { EquipmentLogModule } from 'src/tmc-common/common/components/equipment-log/equipment-log.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    SharedModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    EquipmentLogModule
  ],
  declarations: [
    SmartphoneComponent
  ]
})
export class SmartphoneModule { }

